// src/apiEndpoints.js
// Centralized API endpoints for the Owena Admin Dashboard

const BASE_URL = 'https://api.owenamarketplace.com/v1';

export const API_ENDPOINTS = {
  adminLogin: `${BASE_URL}/admins/authenticate`,
  orders: `${BASE_URL}/orders`,
  products: `${BASE_URL}/products`,
  subscribers: `${BASE_URL}/subscribers`,
  sellers: `${BASE_URL}/sellers`,
  getSellerById: id => `${BASE_URL}/sellers/${id}`,
  activateSeller: email => `${BASE_URL}/admins/sellers/${encodeURIComponent(email)}/activate`,
  updateSellerStatus: id => `${BASE_URL}/admins/sellers/${id}/status`,
  categories: `${BASE_URL}/categories`,
  createCategory: `${BASE_URL}/categories`,
  updateCategory: id => `${BASE_URL}/categories/${id}`,
  deleteCategory: id => `${BASE_URL}/categories/${id}`,
  communities: `${BASE_URL}/communities`,
  createCommunity: `${BASE_URL}/communities`,
  updateCommunity: id => `${BASE_URL}/communities/${id}`,
  deleteCommunity: id => `${BASE_URL}/communities/${id}`,
  updateProduct: (productId, sellerId) => `${BASE_URL}/products/${productId}/?sellerId=${sellerId}`,
  tickets: `${BASE_URL}/tickets`,
  getTicketById: id => `${BASE_URL}/tickets/${id}`,
  updateTicket: id => `${BASE_URL}/tickets/${id}`,
  transactions: `${BASE_URL}/transactions`,
  getTransactionById: id => `${BASE_URL}/transactions/${id}`,
  refunds: `${BASE_URL}/refunds`,
  users: `${BASE_URL}/users`,
  getCustomers: (page = 1, limit = 10) => `${BASE_URL}/users/?page=${page}&limit=${limit}`,

  // Admin/Employee Management
  createAdmin: `${BASE_URL}/admins`,
  getAdmins: `${BASE_URL}/admins`,
  updateAdmin: adminId => `${BASE_URL}/admins/${adminId}`,
  getAdminPermissions: `${BASE_URL}/admins/permissions`,

  // Metrics endpoints
  metrics: {
    users: `${BASE_URL}/metrics/users`,
    sellers: `${BASE_URL}/metrics/sellers`,
    products: `${BASE_URL}/metrics/products`,
    orders: `${BASE_URL}/metrics/orders`,
    sales: `${BASE_URL}/metrics/sales`,
    revenue: `${BASE_URL}/metrics/revenue`,
    walletsTotal: `${BASE_URL}/metrics/wallets/total`,
    earnings: `${BASE_URL}/metrics/earnings`,
    sellerProductsGrouped: (sellerId) => `${BASE_URL}/metrics/sellers/${sellerId}/products/grouped`,
  },

  // Banners
  banners: `${BASE_URL}/banners`,
  updateBanner: id => `${BASE_URL}/banners/${id}`,
  fileUpload: `${BASE_URL}/file/upload`,
  announcements: `${BASE_URL}/announcements`,
  updateAnnouncement: id => `${BASE_URL}/announcements/${id}`,

  // Add other endpoints here as needed
};
